import { useStorageProgressModel } from './storage-progress-bar.model'
import type { StorageProgressBarProps } from './storage-progress-bar.types'
import { StorageProgressBarView } from './storage-progress-bar.view'

export const StorageProgressBar = ({ currentValue, maxValue, ...props }: StorageProgressBarProps) => {
  const storageProgressBarModel = useStorageProgressModel({ currentValue, maxValue })
  return <StorageProgressBarView {...storageProgressBarModel} {...props} />
}
